import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

const BaslerPreset = definePreset(Lara);

export default {
  preset: BaslerPreset,
  options: {
    prefix: 'p',
    darkModeSelector: '.theme-nope', // Don't use dark mode styles from PrimeVue
    cssLayer: true
  }
};
